import React from 'react';
import PropTypes from 'prop-types';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';
import { phoneNumberFormatter } from '../utils/phoneNumberFormatter.mjs';

const CompanyInfo = ({ onClick, data, isCompany, isContact, isLoading }) => {
  if (isLoading)
    return <i className="company-info-spinner fa fa-spinner fa-pulse fa-2x"></i>;
  return data instanceof Object && Object.keys(data).length > 0 ? (
    <div className="company-info" onClick={onClick}>
      {onClick && <i class="fa fa-pencil"></i>}
      <div className="company-info__title">
        {isCompany && <NeuroMessage id='summary.companyInfo.title' tagName='p' />}
        {isContact && <NeuroMessage id='summary.contactInfo.title' tagName='p' />}
      </div>
      <div>
        <span>{data.companyName}</span>
      </div>
      {data.streetAddress && (
        <div>
          <span>{`${data.streetAddress}, ${data.city} ${data.state} ${data.zipCode}`}</span>
        </div>
      )}
      {data.companyPhone && (<div>
        <span>{phoneNumberFormatter(data.companyPhone)}</span>
      </div>)}
      {data.contactName && (<>
        <hr></hr>
        <div>
          <span>{data.contactName}</span>
        </div></>)}
      {data.email && (<div>
        <span>{data.email}</span>
      </div>)}
      {data.contactPhone && (<div>
        <span>{phoneNumberFormatter(data.contactPhone)}</span>
      </div>)}
    </div>
  ) :
    isLoading !== undefined ? <div className="company-info">
      <div className="company-info__title">
        <NeuroMessage id='summary.companyInfo.title' tagName='div' />
      </div>
      <NeuroMessage id='summary.companyInfo.none' />
    </div> : <></>
};

CompanyInfo.propTypes = {
  onClick: PropTypes.func,
  data: PropTypes.shape({
    streetAddress: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    zipCode: PropTypes.string,
    companyName: PropTypes.string,
    companyPhone: PropTypes.string,
    contactName: PropTypes.string,
    email: PropTypes.string,
    contactPhone: PropTypes.string,
  }),
  isCompany: PropTypes.bool,
  isContact: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default CompanyInfo;